import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Bars3Icon } from '@heroicons/react/24/solid';
import MenuItem from './MenuItem';
import IconButton from '../components/IconButton';
import { useSelector } from 'react-redux';

const Sidebar = ({ showIconsOnly, setShowIconsOnly }) => {
  const { filteredMenuItems } = useSelector((state) => state.Auth);
  const location = useLocation();

  const getSelectedMenu = React.useCallback(function findSelectedMenu(path, items) {
    for (let item of items) {
      if (item.to === path) {
        return { parent: null, child: item };
      }
      if (item.children) {
        const selected = findSelectedMenu(path, item.children);
        if (selected) {
          return { parent: item, child: selected.child };
        }
      }
    }
    return null;
  }, []);

  const selectedMenu = useMemo(() => 
    getSelectedMenu(location.pathname, filteredMenuItems)
  , [location.pathname, filteredMenuItems, getSelectedMenu]);

  return (
    <>
        <div className="relative h-[calc(100vh-2.5rem)] bg-card hidden md:block transition-all duration-300 ease-in-out select-none">
            <div className={`mx-auto flex ${showIconsOnly ? 'justify-center' : 'justify-between'} w-full border-b items-center h-[50px]`}>
                <IconButton variant="ghost" size="icon" className="rounded-none" Icon={Bars3Icon} onClick={() => setShowIconsOnly(!showIconsOnly)} />
                <div className={`flex flex-grow ${showIconsOnly ? 'hidden' : 'block'} pl-4`}>
                  <img className="h-full object-cover" src="./app_icon.png" alt="Welcome Bar" />
                </div>
            </div>
            <div className="space-y-4 py-1 border-r h-[100%] overflow-y-auto">
                <div className="space-y-1 px-3 py-2 text-center">
                {filteredMenuItems.map((item, index) => (
                    <MenuItem
                      key={index}
                      name={item.name}
                      Icon={item.Icon || null}
                      path={item.to}
                      type={item.children ? 'menu-group' : 'menu'}
                      showIconsOnly={showIconsOnly}
                      children={item.children}
                      selected={selectedMenu && (selectedMenu.parent === item || selectedMenu.child === item)}
                    />
                ))}
                </div>
            </div>
        </div>

        <div className={`fixed h-[calc(100vh-2.5rem)] bg-card md:hidden transition-all duration-300 ease-in-out select-none ${showIconsOnly ? 'translate-x-[-100%]' : 'translate-x-0'} w-full z-10`}>
            <div className={`mx-auto flex ${showIconsOnly ? 'justify-center' : 'justify-between'} w-full border-b items-center h-[50px]`}>
                <div className={`${showIconsOnly ? 'hidden' : 'block'} pl-3 h-[80%]`}>
                  <img className="h-full object-cover" src="./app_icon.png" alt="Welcome Bar" />
                </div>
                <IconButton variant="ghost" size="icon" Icon={Bars3Icon} onClick={() => setShowIconsOnly(!showIconsOnly)} />
            </div>
            <div className="space-y-4 py-1 border-r h-[100%] overflow-y-auto">
                <div className="space-y-1 px-3 py-2 text-center">
                {filteredMenuItems.map((item, index) => (
                    <MenuItem
                        key={index}
                        name={item.name}
                        Icon={item.Icon || null}
                        path={item.to}
                        type={item.children ? 'menu-group' : 'menu'}
                        showIconsOnly={showIconsOnly}
                        children={item.children}
                        selected={selectedMenu && (selectedMenu.parent === item || selectedMenu.child === item)}
                    />
                ))}
                </div>
            </div>
        </div>
    </>
  );
};

export default Sidebar;
